<div *ngFor="let item of list; let i = index" class="tree-node" [ngStyle]="{ width: item.level * 50 + 'px', 'min-width': '100%' }">
    <div class="node-content" [ngClass]="selectedFolder === item.item.ItemId ? 'node-active' : ''" (click)="redirectHere($event, item, i)" [ngStyle]="{ width: item.level * 50 + 'px', 'min-width': '100%' }">
        <div [ngStyle]="{
                width: (item.level == 0 ? 0 : item.level * 15) + 'px',
                height: '15px'
            }"></div>
        <button (click)="nodeToggle($event, i)" mat-icon-button aria-label="Tree expansion control" *ngIf="item.isReady">
            <mat-icon *ngIf="item.isOpen">expand_more</mat-icon>
            <mat-icon *ngIf="!item.isOpen">chevron_right</mat-icon>
        </button>
        <button disabled mat-icon-button aria-label="Tree expansion control" *ngIf="!item.isReady">
            <mat-icon>chevron_right</mat-icon>
        </button>

        <mat-icon class="mr-16 mat-icon-no-color">folder</mat-icon>
        <div class="m-0 folder-title">
            {{ item.item.Name }}
        </div>
    </div>
    <div *ngIf="item.Children.length > 0 && item.isOpen">
        <app-document-tree-node [list]="item.Children" [parentList]="localParentList" [dmsConfig]="dmsConfig"></app-document-tree-node>
    </div>
</div>